import React from "react";

import { cx } from "~/tools/class-variance";

import { Link } from "../../components/react/link";

export interface BreadcrumbLayoutProps {
	to?: string;
	icon?: React.ReactNode;
	label: React.ReactNode;
}

export const BreadcrumbLayout: React.FC<BreadcrumbLayoutProps> = ({ icon, to, label }) => (
	<button
		className={cx(
			"relative top-nav-button rounded-none first:rounded-l-sm last:rounded-r-sm",
			to == null && "pointer-events-none",
		)}
		type="button"
	>
		{to && <Link className="absolute inset-0" to={to} />}

		{icon != null && <div>{icon}</div>}
		{label != null && <div>{label}</div>}
	</button>
);
